import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';

import { Button } from '@new-components/elements';

import { BankAccountValidationProps } from './types';
import PersonalBankAccount from './illustrations/PersonalBankAccount';
import ActiveBankAccount from './illustrations/ActiveBankAccount';
import { bankAccountVerificationCx } from './styles';

const BankAccountValidation = (props: BankAccountValidationProps) => {
  const [step, setStep] = useState(0);
  const {
    onCancel,
    onSecondCancel,
    onVerify,
    isOpen,
    bankName,
    bankAccount,
    accountName,
    isLoading,
  } = props;

  const content = [
    {
      illustration: <PersonalBankAccount />,
      title: 'No. Rekening Ini Milik Pribadi, Kan?',
      description: `Pastikan nomor rekening ${bankAccount} dari ${bankName} atas nama ${accountName}`,
    },
    {
      illustration: <ActiveBankAccount />,
      title: 'Nomor Rekeningmu Pernah Digunakan Dalam 3 Bulan Terakhir, Kan?',
      description: `Pastikan nomor rekening ${bankAccount} dari ${bankName} pernah kamu gunakan untuk bertransaksi dalam 3 bulan terakhir.`,
    },
  ];

  useEffect(() => {
    if (!isOpen) {
      // set a timeout to prevent glitch in UI
      setTimeout(() => setStep(0), 500);
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen} maxWidth='xs'>
      <div className={bankAccountVerificationCx}>
        <div className='illustration'>{content[step].illustration}</div>
        <div className='title-wrapper'>
          <div className='title'>
            <span>{content[step].title}</span>
          </div>
          <div className='subtitle'>
            <span>{content[step].description} </span>
          </div>
        </div>
        <div className='action-wrapper'>
          {step === 0 ? (
            <>
              <Button
                variant='secondary'
                disabled={isLoading}
                onClick={onCancel}
              >
                Tidak
              </Button>
              <Button onClick={() => setStep(1)} disabled={isLoading}>
                Ya
              </Button>
            </>
          ) : (
            <>
              <Button
                variant='secondary'
                disabled={isLoading}
                onClick={onSecondCancel}
              >
                Tidak
              </Button>
              <Button onClick={onVerify} disabled={isLoading}>
                Ya
              </Button>
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default BankAccountValidation;
